
import React from "react";
import { Button } from "@/components/ui/button";

interface FilterButtonsProps {
  filterPeriod: "all" | "6m" | "3m" | "1m";
  setFilterPeriod: (period: "all" | "6m" | "3m" | "1m") => void;
}

const FilterButtons = ({ filterPeriod, setFilterPeriod }: FilterButtonsProps) => {
  return (
    <div className="flex flex-wrap gap-2 mb-6 print:hidden">
      <Button
        variant={filterPeriod === "all" ? "default" : "outline"}
        size="sm"
        onClick={() => setFilterPeriod("all")}
      >
        All Time
      </Button>
      <Button
        variant={filterPeriod === "6m" ? "default" : "outline"}
        size="sm"
        onClick={() => setFilterPeriod("6m")}
      >
        Last 6 Months
      </Button>
      <Button
        variant={filterPeriod === "3m" ? "default" : "outline"}
        size="sm"
        onClick={() => setFilterPeriod("3m")}
      >
        Last 3 Months
      </Button>
      <Button
        variant={filterPeriod === "1m" ? "default" : "outline"}
        size="sm"
        onClick={() => setFilterPeriod("1m")}
      >
        Last Month
      </Button>
    </div>
  );
};

export default FilterButtons;
